module.exports = __webpack_public_path__ + "static/media/pe.fed5018b.jpg";